import { QBox, QIcon, QTooltip, useFeatureFlag } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

export const InheritedParentIcon = ({
  parentName,
  dataCy,
}: {
  parentName: string;
  dataCy: string;
}) => {
  const { t } = useTranslation();
  const featureFlags = useFeatureFlag();
  const enterpriseAccounts = Boolean(featureFlags['enterprise-accounts']);
  const tooltip = t('tooltips.inheritedFromParent', { parentName });

  if (!enterpriseAccounts) {
    return null;
  }

  return (
    <QTooltip label={tooltip}>
      <QBox
        as="span"
        display="inline-flex"
        flexShrink={0}
        role="img"
        aria-label={tooltip}
        data-cy={dataCy}
      >
        <QIcon iconName="Related" color="blue.400" />
      </QBox>
    </QTooltip>
  );
};
